import React from 'react';
import { createPortal } from 'react-dom';
import { theme } from 'antd';
import MetricsTooltip from '@/comp/MetricsTooltip/MetricsTooltip';
import { PortalWrapper } from './EngineStateTooltip.styles';

export interface TooltipData {
  status: string;
  date: string;
  color: string;
}

interface EngineStateTooltipProps {
  data: TooltipData | null;
  position: { x: number; y: number } | null;
  visible: boolean;
}

const EngineStateTooltip: React.FC<EngineStateTooltipProps> = ({ data, position, visible }) => {
  const { token } = theme.useToken();

  if (!data || !position) return null;

  if (typeof document === 'undefined' || !document.body) {
    return null;
  }

  return createPortal(
    <PortalWrapper $visible={visible} $x={position.x} $y={position.y}>
      <MetricsTooltip
        token={token}
        engineStateOnly
        engineStateDate={data.date}
        engineStatusInfo={{
          color: data.color,
          label: data.status,
        }}
      />
    </PortalWrapper>,
    document.body,
  );
};

export default EngineStateTooltip;
